export type TestStatusType =
	| 'idle'
	| 'pending'
	| 'success'
	| 'error'
	| 'timeout'
	| 'failed';

export interface TestCardProps {
	status: TestStatusType;
	isLoading: boolean;
	buttonText: string;
	credentials: Record<string, string>;
}
